export const HOME = {
  hero: "agency-hero",
  caseGrid: "case-study-grid",
  caseCard: (slug) => `case-study-card-${slug}`,
  pitchForm: "pitch-contact-form",
  pitchName: "pitch-name",
  pitchEmail: "pitch-email",
  pitchBusiness: "pitch-business",
  pitchBorough: "pitch-borough",
  pitchMessage: "pitch-message",
  pitchSubmit: "pitch-submit-button",
  navHome: "nav-home",
  navWork: "nav-work",
  navContact: "nav-contact",
};

export const FBLANDING = {
  hero: "fb-landing-hero",
  form: "fb-landing-form",
  name: "fb-landing-name",
  business: "fb-landing-business",
  phone: "fb-landing-phone",
  email: "fb-landing-email",
  borough: "fb-landing-borough",
  submit: "fb-landing-submit",
  stickySubmit: "fb-landing-sticky-submit",
  success: "fb-landing-success",
};

export const CASE = {
  beforeBlock: "case-before-block",
  afterBlock: "case-after-block",
  backToWork: "back-to-work",
  externalListing: "external-google-listing",
};

export const BULK = {
  boroughSelect: "bulk-borough-select",
  tradeChip: (slug) => `bulk-trade-chip-${slug}`,
  runBtn: "bulk-run-button",
  resultRow: (i) => `bulk-result-row-${i}`,
  exportBtn: "bulk-export-csv-button",
  scheduleBtn: "bulk-schedule-button",
  scheduleNameInput: "schedule-name-input",
  scheduleHourInput: "schedule-hour-input",
  scheduleSubmit: "schedule-submit-button",
  jobRow: (i) => `lead-job-row-${i}`,
  jobRunNow: (i) => `lead-job-run-now-${i}`,
  jobDelete: (i) => `lead-job-delete-${i}`,
};
